// This section can contain all product types
var colorOptionsMain = [
  {
    "color_name": "Canvas",
    "type": "block",
    "main": "#f2ebde",
    "product": {
      "standard-pillow": "pillowcase-pair-in-canvas",
      "euro-pillow": "euro-pillowcase-pair-in-canvas",
      "king-pillow": "king-pillowcase-pair-in-canvas",
      "fitted-sheet": "fitted-sheet-canvas",
      "flat-sheet": "flat-sheet-canvas",
      "duvet-cover": "duvet-cover-in-canvas"
    }
  },
  {
    "color_name": "Prism",
    "type": "block",
    "main": "#FAFAFA",
    "product": {
      "standard-pillow": "pillowcase-pair-in-prism",
      "king-pillow": "king-pillowcase-pair-in-prism",
      "fitted-sheet": "fitted-sheet-prism",
      "flat-sheet": "flat-sheet-prism",
      "duvet-cover": "duvet-cover-in-prism",
      "euro-pillow": "euro-pillowcase-pair-in-prism"
    }
  },
  {
    "color_name": "Sterling",
    "type": "block",
    "main": "#bebcb7ff",
    "product": {
      "standard-pillow": "pillowcase-pair-in-sterling",
      "euro-pillow": "euro-pillowcase-pair-in-sterling",
      "king-pillow": "king-pillowcase-pair-in-sterling",
      "fitted-sheet": "fitted-sheet-in-sterling",
      "flat-sheet": "flat-sheet-in-sterling",
      "duvet-cover": "duvet-cover-in-sterling"
    }
  },
  {
    "color_name": "Slate",
    "type": "block",
    "main": "#576a82",
    "product": {
      "standard-pillow": "pillowcase-pair-in-slate",
      "euro-pillow": "euro-pillowcase-pair-in-slate",
      "king-pillow": "king-pillowcase-pair-in-slate",
      "fitted-sheet": "fitted-sheet-in-slate",
      "flat-sheet": "flat-sheet-in-slate",
      "duvet-cover": "duvet-cover-in-slate"
    }
  },
  {
    "color_name": "Clay",
    "type": "block",
    "main": "#ce8d8e",
    "product": {
      "standard-pillow": "pillowcase-pair-in-clay",
      "euro-pillow": "euro-pillowcase-pair-in-clay",
      "king-pillow": "king-pillowcase-pair-in-clay",
      "duvet-cover": "duvet-cover-in-clay"
    }
  },
  {
    "color_name": "Contrast Edge, Canvas with Cinder",
    "type": "contrast",
    "main": "#f2eadb",
    "minor": "#2c2f32",
    "product": {
      "euro-pillow": "euro-pillowcase-pair-in-contrast-edge-canvas-with-cinder",
      "duvet-cover": "duvet-cover-in-contrast-edge-canvas-with-cinder"
    }
  },
  {
    "color_name": "Contrast Edge, Prism with Carob",
    "type": "contrast",
    "main": "#F9F9F9",
    "minor": "#7f674f",
    "product": {
      "duvet-cover": "duvet-cover-in-contrast-edge-prism-with-carob"
    }
  },
  {
    "color_name": "Contrast Edge, Canvas with Navy",
    "type": "contrast",
    "main": "#ece6d6",
    "minor": "#12126b",
    "product": {
      "duvet-cover": "duvet-cover-in-contrast-edge-canvas-with-navy",
      "euro-pillow": "euro-pillowcase-pair-in-contrast-edge-canvas-with-navy",
      "king-pillow": "king-pillowcase-pair-in-contrast-edge-canvas-with-navy",
      "standard-pillow": "pillowcase-pair-in-contrast-edge-canvas-with-navy"
    }
  },
  {
    "color_name": "Eggplant",
    "type": "block",
    "main": "#452a26",
    "product": {
      "duvet-cover": "duvet-cover-in-eggplant",
      "euro-pillow": "euro-pillowcase-pair-in-eggplant",
      "king-pillow": "king-pillowcase-pair-in-eggplant",
      "standard-pillow": "pillowcase-pair-in-eggplant"
    }
  },
  {
    "color_name": "Melon",
    "type": "block",
    "main": "#c0bfaa",
    "product": {
      "duvet-cover": "duvet-cover-in-melon",
      "euro-pillow": "euro-pillowcase-pair-in-melon",
      "king-pillow": "king-pillowcase-pair-in-melon",
      "standard-pillow": "pillowcase-pair-in-melon"
    }
  },
  {
    "color_name": "Maize",
    "type": "block",
    "main": "#cfbd81",
    "product": {
      "duvet-cover": "duvet-cover-in-maize",
      "euro-pillow": "euro-pillowcase-pair-in-maize",
      "king-pillow": "king-pillowcase-pair-in-maize",
      "standard-pillow": "pillowcase-pair-in-maize"
    }
  }
]

// This sections can only contain `fitted-sheet` and `flat-sheet`
var colorOptionsSecondary = [
  {
    "color_name": "Canvas",
    "type": "block",
    "main": "#f2ebde",
    "product": {
      "fitted-sheet": "fitted-sheet-canvas",
      "flat-sheet": "flat-sheet-canvas"
    }
  },
  {
    "color_name": "Prism",
    "type": "block",
    "main": "#FAFAFA",
    "product": {
      "fitted-sheet": "fitted-sheet-prism",
      "flat-sheet": "flat-sheet-prism"
    }
  },
  {
    "color_name": "Sterling",
    "type": "block",
    "main": "#bebcb7ff",
    "product": {
      "fitted-sheet": "fitted-sheet-in-sterling",
      "flat-sheet": "flat-sheet-in-sterling"
    }
  },
  {
    "color_name": "Slate",
    "type": "block",
    "main": "#576a82",
    "product": {
      "fitted-sheet": "fitted-sheet-in-slate",
      "flat-sheet": "flat-sheet-in-slate"
    }
  }
  ,{
    "color_name": "Clay",
    "type": "block",
    "main": "#ce8d8e",
    "product": {
      "fitted-sheet": "fitted-sheet-in-clay",
      "flat-sheet": "flat-sheet-in-clay"
    }
  }
  ,{
    "color_name": "Eggplant",
    "type": "block",
    "main": "#452a26",
    "product": {
      "fitted-sheet": "fitted-sheet-in-eggplant",
      "flat-sheet": "flat-sheet-in-eggplant"
    }
  }
  ,{
    "color_name": "Melon",
    "type": "block",
    "main": "#c0bfaa",
    "product": {
      "fitted-sheet": "fitted-sheet-in-melon",
      "flat-sheet": "flat-sheet-in-melon"
    }
  }
  ,{
    "color_name": "Maize",
    "type": "block",
    "main": "#cfbd81",
    "product": {
      "fitted-sheet": "fitted-sheet-in-maize",
      "flat-sheet": "flat-sheet-in-maize"
    }
  }
]


// ONLOADS 

document.addEventListener('DOMContentLoaded', () => {
  shuffleColors()
  updateSelectionFrame()

  setTimeout(() => {document.querySelector('.bys-container').classList.remove('load')}, 2000)
})

// UPDATE SELECTION FRAME 

function updateSelectionFrame() {
  var bottomBar = document.querySelector('.bottom-bar')
  var pieces = bottomBar.getAttribute('data-pieces')


  if (pieces == 4) {
    var block1Index = document.querySelector('[data-name="pillow-1" ]').getAttribute('data-index')
    var block2Index = document.querySelector('[data-name="pillow-2" ]').getAttribute('data-index')
    var block3Index = document.querySelector('[data-name="fitted-sheet" ]').getAttribute('data-index')
    var block4Index = document.querySelector('[data-name="duvet-cover" ]').getAttribute('data-index')
    
    var colorName1 = colorOptionsMain[block1Index].color_name
    var colorName2 = colorOptionsSecondary[block3Index].color_name
    var colorName3 =  colorOptionsMain[block4Index].color_name

    document.querySelector('.selection-one [data-color]').innerHTML = colorName1
    document.querySelector('.selection-two [data-color]').innerHTML = colorName2
    document.querySelector('.selection-three [data-color]').innerHTML = colorName3
  } else  if (pieces == 5) {
      var block1Index = document.querySelector('[data-name="pillow-1" ]').getAttribute('data-index')
      var block3Index = document.querySelector('[data-name="flat-sheet" ]').getAttribute('data-index')
      var block4Index = document.querySelector('[data-name="fitted-sheet" ]').getAttribute('data-index')
      var block5Index = document.querySelector('[data-name="duvet-cover" ]').getAttribute('data-index')
    
      var colorName1 = colorOptionsMain[block1Index].color_name
      var colorName3 = colorOptionsSecondary[block3Index].color_name
      var colorName4 = colorOptionsSecondary[block4Index].color_name
      var colorName5 = colorOptionsMain[block5Index].color_name
  
      document.querySelector('.selection-one [data-color]').innerHTML = colorName1
      document.querySelector('.selection-two [data-color]').innerHTML = colorName4
      document.querySelector('.selection-three [data-color]').innerHTML = colorName3
      document.querySelector('.selection-four [data-color]').innerHTML = colorName5
  } else if (pieces == 6) {
      var block1Index = document.querySelector('[data-name="pillow-1" ]').getAttribute('data-index')
      var block2Index = document.querySelector('[data-name="pillow-2" ]').getAttribute('data-index')
      var block3Index = document.querySelector('[data-name="pillow-3" ]').getAttribute('data-index')
      var block4Index = document.querySelector('[data-name="pillow-4" ]').getAttribute('data-index')
      var block5Index = document.querySelector('[data-name="fitted-sheet" ]').getAttribute('data-index')
      var block6Index = document.querySelector('[data-name="duvet-cover" ]').getAttribute('data-index')
    
      var colorName1 = colorOptionsMain[block1Index].color_name
      var colorName2 = colorOptionsMain[block3Index].color_name
      var colorName3 = colorOptionsSecondary[block5Index].color_name
      var colorName4 = colorOptionsMain[block6Index].color_name
   
  
      document.querySelector('.selection-one [data-color]').innerHTML = colorName1
      document.querySelector('.selection-two [data-color]').innerHTML = colorName2
      document.querySelector('.selection-three [data-color]').innerHTML = colorName3
      document.querySelector('.selection-four [data-color]').innerHTML = colorName4
  } else  if (pieces == 7) {
      var block1Index = document.querySelector('[data-name="pillow-1" ]').getAttribute('data-index')
      var block2Index = document.querySelector('[data-name="pillow-2" ]').getAttribute('data-index')
      var block3Index = document.querySelector('[data-name="pillow-3" ]').getAttribute('data-index')
      var block4Index = document.querySelector('[data-name="pillow-4" ]').getAttribute('data-index')
      var block5Index = document.querySelector('[data-name="flat-sheet" ]').getAttribute('data-index')
      var block6Index = document.querySelector('[data-name="fitted-sheet" ]').getAttribute('data-index')
      var block7Index = document.querySelector('[data-name="duvet-cover" ]').getAttribute('data-index')
    
      var colorName1 = colorOptionsMain[block1Index].color_name
      var colorName2 = colorOptionsMain[block3Index].color_name
      var colorName3 = colorOptionsSecondary[block5Index].color_name
      var colorName4 = colorOptionsSecondary[block6Index].color_name
      var colorName5 = colorOptionsMain[block7Index].color_name
  
      document.querySelector('.selection-one [data-color]').innerHTML = colorName1
      document.querySelector('.selection-two [data-color]').innerHTML = colorName2
      document.querySelector('.selection-three [data-color]').innerHTML = colorName3
      document.querySelector('.selection-four [data-color]').innerHTML = colorName4
      document.querySelector('.selection-five [data-color]').innerHTML = colorName5

  }
}

// GET PRODUCT 


function getProduct(product, index) {
  console.log(`🛍️ GETPRODUCT: Loading ${product} with index ${index} (${colorOptionsMain[index]?.color_name || colorOptionsSecondary[index]?.color_name})`);
  var bottomBar = document.querySelector('.bottom-bar')
  var pieces = bottomBar.getAttribute('data-pieces')

  var addProduct = undefined
  var addProduct2 = undefined
  if (product == "pillow-1") {
    var addProduct = colorOptionsMain[index].product["standard-pillow"]
    var addProduct2 = colorOptionsMain[index].product["euro-pillow"]
    
    // If no standard pillow, try to use euro pillow as fallback
    if (!addProduct && addProduct2) {
      console.warn(`⚠️ No standard-pillow for ${colorOptionsMain[index].color_name}, using euro-pillow as fallback`);
      addProduct = addProduct2;
    }
    
    if (!addProduct) {
      console.error(`❌ No pillow products at all for ${colorOptionsMain[index].color_name} at index ${index}`);
      return;
    }
    
    document.querySelector(".position-1-product .product-image").innerHTML = ""
    var color = colorOptionsMain[index].color_name
    console.log(`🛒 Fetching product: ${addProduct} for ${color}`);
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-1-product .product-image").appendChild(elem);
      document.querySelector(".position-1-product [data-color]").innerHTML = color

      document.querySelector('.position-1-product .size-selector').innerHTML = ""
      document.querySelector('.position-1-product').setAttribute('data-varid', '')
      document.querySelector('.position-1-product [variant-price]').innerHTML = ""
      document.querySelector('.position-1-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-1-product').classList.remove('product-chosen')

      var listItem1 = document.createElement("li")
      var listButton1 = document.createElement("button")
      listButton1.classList.add('plain-button')
      listButton1.onclick = function () { choosePillowProduct(this, 'standard-pillow', index) }
      listButton1.innerHTML = "Standard"
      listItem1.appendChild(listButton1);
      document.querySelector('.position-1-product .size-selector').appendChild(listItem1)
      var listItem2 = document.createElement("li")
      var listButton2 = document.createElement("button")
      listButton2.classList.add('plain-button')
      listButton2.onclick = function () { choosePillowProduct(this, 'euro-pillow', index) }
      listButton2.innerHTML = "Euro"
      listItem2.appendChild(listButton2);
      document.querySelector('.position-1-product .size-selector').appendChild(listItem2)
      
      // Auto-select standard pillow if available, otherwise euro
      if (addProduct === colorOptionsMain[index].product["standard-pillow"]) {
        listButton1.click(); // Auto-select standard
      } else if (addProduct === colorOptionsMain[index].product["euro-pillow"]) {
        listButton2.click(); // Auto-select euro as fallback
      }
    }).then(
      fetch(
        window.Shopify.routes.root + `products/${addProduct2}.json`,
        {
          method: 'GET'
        }
      ).then(response2 => {
        return response2.json()
      }).then(data2 => {
        var elem = document.createElement("img");
        elem.setAttribute("src", data2.product.images[0].src);
        elem.setAttribute("alt", "product-image");
        elem.classList.add('euro')
        document.querySelector(".position-1-product .product-image").appendChild(elem);
      }
    ))
  } else if (product == 'pillow-2' && pieces == "6") {
    var addProduct = colorOptionsMain[index].product["standard-pillow"]
    var addProduct2 = colorOptionsMain[index].product["euro-pillow"]
    
    // If no standard pillow, try to use euro pillow as fallback
    if (!addProduct && addProduct2) {
      console.warn(`⚠️ No standard-pillow for ${colorOptionsMain[index].color_name}, using euro-pillow as fallback`);
      addProduct = addProduct2;
    }
    
    if (!addProduct) {
      console.error(`❌ No pillow products at all for ${colorOptionsMain[index].color_name} at index ${index}`);
      return;
    }
    
    document.querySelector(".position-2-product .product-image").innerHTML = ""
    var color = colorOptionsMain[index].color_name
    console.log(`🛒 Fetching pillow-2: ${addProduct} for ${color}`);
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-2-product .product-image").appendChild(elem);
      document.querySelector(".position-2-product [data-color]").innerHTML = color;

      document.querySelector('.position-2-product .size-selector').innerHTML = ""
      document.querySelector('.position-2-product').setAttribute('data-varid', '')
      document.querySelector('.position-2-product [variant-price]').innerHTML = ""
      document.querySelector('.position-2-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-2-product').classList.remove('product-chosen')

      var listItem1 = document.createElement("li")
      var listButton1 = document.createElement("button")
      listButton1.classList.add('plain-button')
      listButton1.onclick = function () { choosePillowProduct(this, 'standard-pillow', index) }
      listButton1.innerHTML = "Standard"
      listItem1.appendChild(listButton1);
      document.querySelector('.position-2-product .size-selector').appendChild(listItem1)
      var listItem2 = document.createElement("li")
      var listButton2 = document.createElement("button")
      listButton2.classList.add('plain-button')
      listButton2.onclick = function () { choosePillowProduct(this, 'euro-pillow', index) }
      listButton2.innerHTML = "Euro"
      listItem2.appendChild(listButton2);
      document.querySelector('.position-2-product .size-selector').appendChild(listItem2)
      
      // Auto-select standard pillow if available, otherwise euro
      if (addProduct === colorOptionsMain[index].product["standard-pillow"]) {
        listButton1.click(); // Auto-select standard
      } else if (addProduct === colorOptionsMain[index].product["euro-pillow"]) {
        listButton2.click(); // Auto-select euro as fallback
      }
    }).then(
      fetch(
        window.Shopify.routes.root + `products/${addProduct2}.json`,
        {
          method: 'GET'
        }
      ).then(response2 => {
        return response2.json()
      }).then(data2 => {
        var elem = document.createElement("img");
        elem.setAttribute("src", data2.product.images[0].src);
        elem.setAttribute("alt", "product-image");
        elem.classList.add('euro')
        document.querySelector(".position-2-product .product-image").appendChild(elem);
      }
    ))

  
  } else if (product == 'pillow-2' && pieces == "7") {
    var addProduct = colorOptionsMain[index].product["standard-pillow"]
    var addProduct2 = colorOptionsMain[index].product["euro-pillow"]
    
    // If no standard pillow, try to use euro pillow as fallback
    if (!addProduct && addProduct2) {
      console.warn(`⚠️ No standard-pillow for ${colorOptionsMain[index].color_name}, using euro-pillow as fallback`);
      addProduct = addProduct2;
    }
    
    if (!addProduct) {
      console.error(`❌ No pillow products at all for ${colorOptionsMain[index].color_name} at index ${index}`);
      return;
    }
    
    document.querySelector(".position-2-product .product-image").innerHTML = ""
    var color = colorOptionsMain[index].color_name
    console.log(`🛒 Fetching pillow-2: ${addProduct} for ${color}`);
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-2-product .product-image").appendChild(elem);
      document.querySelector(".position-2-product [data-color]").innerHTML = color

      document.querySelector('.position-2-product .size-selector').innerHTML = ""
      document.querySelector('.position-2-product').setAttribute('data-varid', '')
      document.querySelector('.position-2-product [variant-price]').innerHTML = ""
      document.querySelector('.position-2-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-2-product').classList.remove('product-chosen')

      var listItem1 = document.createElement("li")
      var listButton1 = document.createElement("button")
      listButton1.classList.add('plain-button')
      listButton1.onclick = function () { choosePillowProduct(this, 'standard-pillow', index) }
      listButton1.innerHTML = "Standard"
      listItem1.appendChild(listButton1);
      document.querySelector('.position-2-product .size-selector').appendChild(listItem1)
      var listItem2 = document.createElement("li")
      var listButton2 = document.createElement("button")
      listButton2.classList.add('plain-button')
      listButton2.onclick = function () { choosePillowProduct(this, 'euro-pillow', index) }
      listButton2.innerHTML = "Euro"
      listItem2.appendChild(listButton2);
      document.querySelector('.position-2-product .size-selector').appendChild(listItem2)
      
      // Auto-select standard pillow if available, otherwise euro
      if (addProduct === colorOptionsMain[index].product["standard-pillow"]) {
        listButton1.click(); // Auto-select standard
      } else if (addProduct === colorOptionsMain[index].product["euro-pillow"]) {
        listButton2.click(); // Auto-select euro as fallback
      }
    }).then(
      fetch(
        window.Shopify.routes.root + `products/${addProduct2}.json`,
        {
          method: 'GET'
        }
      ).then(response2 => {
        return response2.json()
      }).then(data2 => {
        var elem = document.createElement("img");
        elem.setAttribute("src", data2.product.images[0].src);
        elem.setAttribute("alt", "product-image");
        elem.classList.add('euro')
        document.querySelector(".position-2-product .product-image").appendChild(elem);
      }
    ))
  } else if (product == 'fitted-sheet' && pieces == "4") {
    var addProduct = colorOptionsSecondary[index].product["fitted-sheet"]
      document.querySelector(".position-2-product .product-image").innerHTML = ""
      var color = colorOptionsSecondary[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-2-product .product-image").appendChild(elem);
      document.querySelector(".position-2-product [data-color]").innerHTML = color
      document.querySelector('.position-2-product .size-selector').innerHTML = ""
      document.querySelector('.position-2-product [variant-price]').innerHTML = ""
      document.querySelector('.position-2-product').setAttribute('data-varid', '')
      document.querySelector('.position-2-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-2-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-2-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'fitted-sheet' && pieces == "5") {
    var addProduct = colorOptionsSecondary[index].product["fitted-sheet"]
      document.querySelector(".position-2-product .product-image").innerHTML = ""
      var color = colorOptionsSecondary[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-2-product .product-image").appendChild(elem);
      document.querySelector(".position-2-product [data-color]").innerHTML = color

      document.querySelector('.position-2-product .size-selector').innerHTML = ""
      document.querySelector('.position-2-product [variant-price]').innerHTML = ""
      document.querySelector('.position-2-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-2-product').setAttribute('data-varid', '')
      document.querySelector('.position-2-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-2-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'fitted-sheet' && pieces == "6") {
    var addProduct = colorOptionsSecondary[index].product["fitted-sheet"]
      document.querySelector(".position-3-product .product-image").innerHTML = ""
      var color = colorOptionsSecondary[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-3-product .product-image").appendChild(elem);
      document.querySelector(".position-3-product [data-color]").innerHTML = color

      document.querySelector('.position-3-product .size-selector').innerHTML = ""
       document.querySelector('.position-3-product [variant-price]').innerHTML = ""
      document.querySelector('.position-3-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-3-product').setAttribute('data-varid', '')
      document.querySelector('.position-3-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-3-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'fitted-sheet' && pieces == "7") {
    var addProduct = colorOptionsSecondary[index].product["fitted-sheet"]
      document.querySelector(".position-3-product .product-image").innerHTML = ""
      var color = colorOptionsSecondary[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-3-product .product-image").appendChild(elem);
      document.querySelector(".position-3-product [data-color]").innerHTML = color

      document.querySelector('.position-3-product .size-selector').innerHTML = ""
      document.querySelector('.position-3-product [variant-price]').innerHTML = ""
      document.querySelector('.position-3-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-3-product').setAttribute('data-varid', '')
      document.querySelector('.position-3-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-3-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'flat-sheet' && pieces == "5") {
    var addProduct = colorOptionsSecondary[index].product["flat-sheet"]
    
    if (!addProduct) {
      console.error(`❌ No flat-sheet product for ${colorOptionsSecondary[index].color_name} at index ${index}`);
      return;
    }
    
    document.querySelector(".position-3-product .product-image").innerHTML = ""
    var color = colorOptionsSecondary[index].color_name
    console.log(`🛒 Fetching flat-sheet: ${addProduct} for ${color}`);
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-3-product .product-image").appendChild(elem);
      document.querySelector(".position-3-product [data-color]").innerHTML = color

      document.querySelector('.position-3-product .size-selector').innerHTML = ""
      document.querySelector('.position-3-product [variant-price]').innerHTML = ""
      document.querySelector('.position-3-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-3-product').setAttribute('data-varid', '')
      document.querySelector('.position-3-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-3-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'flat-sheet' && pieces == "7") {
    var addProduct = colorOptionsSecondary[index].product["flat-sheet"]
      document.querySelector(".position-4-product .product-image").innerHTML = ""
      var color = colorOptionsSecondary[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-4-product .product-image").appendChild(elem);
      document.querySelector(".position-4-product [data-color]").innerHTML = color

      document.querySelector('.position-4-product .size-selector').innerHTML = ""
       document.querySelector('.position-4-product [variant-price]').innerHTML = ""
      document.querySelector('.position-4-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-4-product').setAttribute('data-varid', '')
      document.querySelector('.position-4-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-4-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'duvet-cover' && pieces == "4") {
    var addProduct = colorOptionsMain[index].product["duvet-cover"]
      document.querySelector(".position-3-product .product-image").innerHTML = ""
      var color = colorOptionsMain[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-3-product .product-image").appendChild(elem);
      document.querySelector(".position-3-product [data-color]").innerHTML = color

      document.querySelector('.position-3-product .size-selector').innerHTML = ""
      document.querySelector('.position-3-product [variant-price]').innerHTML = ""
      document.querySelector('.position-3-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-3-product').setAttribute('data-varid', '')
      document.querySelector('.position-3-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-3-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'duvet-cover' && pieces == "5") {
    var addProduct = colorOptionsMain[index].product["duvet-cover"]
      document.querySelector(".position-4-product .product-image").innerHTML = ""
      var color = colorOptionsMain[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-4-product .product-image").appendChild(elem);
      document.querySelector(".position-4-product [data-color]").innerHTML = color

      document.querySelector('.position-4-product .size-selector').innerHTML = ""
      document.querySelector('.position-4-product [variant-price]').innerHTML = ""
      document.querySelector('.position-4-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-4-product').setAttribute('data-varid', '')
      document.querySelector('.position-4-product').classList.remove('product-chosen')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-4-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'duvet-cover' && pieces == "6") {
    var addProduct = colorOptionsMain[index].product["duvet-cover"]
      document.querySelector(".position-4-product .product-image").innerHTML = ""
      var color = colorOptionsMain[index].color_name
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-4-product .product-image").appendChild(elem);
      document.querySelector(".position-4-product [data-color]").innerHTML = color

      document.querySelector('.position-4-product .size-selector').innerHTML = ""
      document.querySelector('.position-4-product [variant-price]').innerHTML = ""
      document.querySelector('.position-4-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-4-product').classList.remove('product-chosen')
      document.querySelector('.position-4-product').setAttribute('data-varid', '')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-4-product .size-selector').appendChild(listItem)
      }
    })
  } else if (product == 'duvet-cover' && pieces == "7") {
    var addProduct = colorOptionsMain[index].product["duvet-cover"]
    var color = colorOptionsMain[index].color_name
      document.querySelector(".position-5-product .product-image").innerHTML = ""
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var elem = document.createElement("img");
      elem.setAttribute("src", data.product.images[0].src);
      elem.setAttribute("alt", "product-image");
      document.querySelector(".position-5-product .product-image").appendChild(elem);
      document.querySelector(".position-5-product [data-color]").innerHTML = color

      document.querySelector('.position-5-product .size-selector').innerHTML = ""
      document.querySelector('.position-5-product [variant-price]').innerHTML = ""
      document.querySelector('.position-5-product .select-size').innerHTML = "(Select size)"
      document.querySelector('.position-5-product').classList.remove('product-chosen')
      document.querySelector('.position-5-product').setAttribute('data-varid', '')

      for (let i = 0; i < data.product.variants.length; i++) {
        const element = data.product.variants[i];
        
        var listItem = document.createElement("li")
        var listButton = document.createElement("button")
        listButton.classList.add('plain-button')
        listButton.onclick = function () { chooseVaraint(this, element.id, element.title, element.price) }
        listButton.innerHTML = element.title
        listItem.appendChild(listButton);
        document.querySelector('.position-5-product .size-selector').appendChild(listItem)
      }
    })
  }
}




// ADD TO CART 

function showSelection() {
  document.querySelector('.add-to-cart-container').classList.add('active')
  document.body.classList.add('size-select-open')
}

function hideSelection() {
  document.querySelector('.add-to-cart-container').classList.remove('active')
  document.body.classList.remove('size-select-open')
}

function readyToAdd() {
  let items = []  
  var bottomBar = document.querySelector('.bottom-bar')
  var pieces = bottomBar.getAttribute('data-pieces')

  if (pieces == 4) {
    var varId1 = document.querySelector('.position-1-product').getAttribute('data-varid')
    var varId2 = document.querySelector('.position-2-product').getAttribute('data-varid')
    var varId3 = document.querySelector('.position-3-product').getAttribute('data-varid')

    items = [
        {
          id: varId1,
          quantity: 1
        },
        {
          id: varId2,
          quantity: 1
        },
        {
          id: varId3,
          quantity: 1
        }
      ] 
    }else  if (pieces == 5) {
      var varId1 = document.querySelector('.position-1-product').getAttribute('data-varid')
      var varId2 = document.querySelector('.position-2-product').getAttribute('data-varid')
      var varId3 = document.querySelector('.position-3-product').getAttribute('data-varid')
      var varId4 = document.querySelector('.position-4-product').getAttribute('data-varid')
      items = [
        {
          id: varId1,
          quantity: 1
        },
        {
          id: varId2,
          quantity: 1
        },
        {
          id: varId3,
          quantity: 1
        },
        {
          id: varId4,
          quantity: 1
        }
      ] 
  } else if (pieces == 6) {
      var varId1 = document.querySelector('.position-1-product').getAttribute('data-varid')
      var varId2 = document.querySelector('.position-2-product').getAttribute('data-varid')
      var varId3 = document.querySelector('.position-3-product').getAttribute('data-varid')
      var varId4 = document.querySelector('.position-4-product').getAttribute('data-varid')
      items = [
        {
          id: varId1,
          quantity: 1
        },
        {
          id: varId2,
          quantity: 1
        },
        {
          id: varId3,
          quantity: 1
        },
        {
          id: varId4,
          quantity: 1
        }
      ] 
  } else  if (pieces == 7) {
    var varId1 = document.querySelector('.position-1-product').getAttribute('data-varid')
    var varId2 = document.querySelector('.position-2-product').getAttribute('data-varid')
    var varId3 = document.querySelector('.position-3-product').getAttribute('data-varid')
    var varId4 = document.querySelector('.position-4-product').getAttribute('data-varid')
    var varId5 = document.querySelector('.position-5-product').getAttribute('data-varid')
    items = [
      {
        id: varId1,
        quantity: 1
      },
      {
        id: varId2,
        quantity: 1
      },
      {
        id: varId3,
        quantity: 1
      },
      {
        id: varId4,
        quantity: 1
      },
      {
        id: varId5,
        quantity: 1
      }
    ] 
  } 

  if(items != []){
    addSetToCart(items)
  }
}


function choosePillowProduct(e, pillow, i, king) {
  var index = i
  var addProduct = colorOptionsMain[index].product[pillow]
    fetch(
      window.Shopify.routes.root + `products/${addProduct}.json`,
      {
        method: 'GET'
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      var price = theme.Currency.formatMoney(data.product.variants[0].price, theme.moneyFormat)

      var parent = e.closest('.position-product')
      var openSizeSelector = parent.querySelector('.select-size')
      var variantPrice = parent.querySelector('[variant-price]')
      if (pillow == "euro-pillow") {
      var variantID = data.product.variants[0].id
        
        openSizeSelector.innerText = "Euro"
        parent.classList.remove('standard-selected')
        parent.classList.remove('king-selected')
        parent.classList.add('euro-selected')
      } else if (pillow == "standard-pillow" && king == undefined) {
      var variantID = data.product.variants[0].id
        openSizeSelector.innerText = "Standard"
        parent.classList.add('standard-selected')
        parent.classList.remove('king-selected')
        parent.classList.remove('euro-selected')
      } else if (king != undefined) {
        openSizeSelector.innerText = "King"
      var variantID = data.product.variants[1].id
        price = theme.Currency.formatMoney(data.product.variants[1].price, theme.moneyFormat)
        parent.classList.remove('euro-selected')
        parent.classList.add('king-selected')
        parent.classList.remove('standard-selected')
      }
      variantPrice.innerText = price
      openSizeSelector.classList.remove('active')
      parent.setAttribute('data-varid', variantID)
      parent.classList.add('product-chosen')
    })
}



function chooseVaraint (e, id, title, varPrice) {
      var variantID = id
      var price = theme.Currency.formatMoney(varPrice, theme.moneyFormat)

      var parent = e.closest('.position-product')
      var openSizeSelector = parent.querySelector('.select-size')
      var variantPrice = parent.querySelector('[variant-price]')
      openSizeSelector.innerText = title
      variantPrice.innerText = price
  
      openSizeSelector.classList.remove('active')
      parent.setAttribute('data-varid', variantID)
      parent.classList.add('product-chosen')
}


function openSizeSelector(e) {
  var sizeTriggers = document.querySelectorAll('.select-size')

  for (let i = 0; i < sizeTriggers.length; i++) {
    const element = sizeTriggers[i];
    if (element == e) {
      element.classList.toggle('active')
    } else {
      element.classList.remove('active')
    }
  } 
}



// SHUFFLE 
  function shuffleColors() {
    console.log('🎲 SHUFFLE: Starting shuffle function');
    // Generate random indices that are filtered to only include colors with available products
    var availablePillowColors = colorOptionsMain.filter((color, index) => 
      color.product && (color.product['standard-pillow'] || color.product['euro-pillow'])
    );
    var availableFlatSheetColors = colorOptionsSecondary.filter((color, index) => 
      color.product && color.product['flat-sheet']
    );
    var availableFittedSheetColors = colorOptionsSecondary.filter((color, index) => 
      color.product && color.product['fitted-sheet']
    );
    var availableDuvetColors = colorOptionsMain.filter((color, index) => 
      color.product && color.product['duvet-cover']
    );
    
    console.log('🎲 SHUFFLE: Available colors:', {
      pillows: availablePillowColors.length,
      flatSheets: availableFlatSheetColors.length,
      fittedSheets: availableFittedSheetColors.length, 
      duvets: availableDuvetColors.length
    });

    // Get random colors from filtered arrays
    var RandomPillowColor1 = availablePillowColors[Math.floor(Math.random() * availablePillowColors.length)];
    var RandomPillowColor2 = availablePillowColors[Math.floor(Math.random() * availablePillowColors.length)];
    var RandomFlatSheetColor = availableFlatSheetColors[Math.floor(Math.random() * availableFlatSheetColors.length)];
    var RandomFittedSheetColor = availableFittedSheetColors[Math.floor(Math.random() * availableFittedSheetColors.length)];
    var RandomDuvetColor = availableDuvetColors[Math.floor(Math.random() * availableDuvetColors.length)];

    // Find the indices in the original arrays
    var RandomNumber1 = colorOptionsMain.findIndex(color => color.color_name === RandomPillowColor1.color_name);
    var RandomNumber2 = colorOptionsMain.findIndex(color => color.color_name === RandomPillowColor2.color_name);
    var RandomNumber3 = colorOptionsSecondary.findIndex(color => color.color_name === RandomFlatSheetColor.color_name);
    var RandomNumber4 = colorOptionsSecondary.findIndex(color => color.color_name === RandomFittedSheetColor.color_name);
    var RandomNumber5 = colorOptionsMain.findIndex(color => color.color_name === RandomDuvetColor.color_name);
    
    console.log('🎲 SHUFFLE: Selected indices:', {
      pillow1: `${RandomNumber1} (${RandomPillowColor1.color_name})`,
      pillow2: `${RandomNumber2} (${RandomPillowColor2.color_name})`, 
      flatSheet: `${RandomNumber3} (${RandomFlatSheetColor.color_name})`,
      fittedSheet: `${RandomNumber4} (${RandomFittedSheetColor.color_name})`,
      duvet: `${RandomNumber5} (${RandomDuvetColor.color_name})`
    });

    document.querySelector('.position-1-product').classList.remove('euro-selected')
    document.querySelector('.position-2-product').classList.remove('euro-selected')


    var pillow1 = document.querySelector('[data-name="pillow-1"]')
    var pillow2 = document.querySelector('[data-name="pillow-2"]')
    var pillow3 = document.querySelector('[data-name="pillow-3"]')
    var pillow4 = document.querySelector('[data-name="pillow-4"]')
    var flatSheet = document.querySelector('[data-name="flat-sheet"]')
    var fittedSheet = document.querySelector('[data-name="fitted-sheet"]')
    var duvetCover= document.querySelector('[data-name="duvet-cover"]')

    pillow1.setAttribute('data-index', RandomNumber1)
    if (colorOptionsMain[RandomNumber1].type == 'contrast') {
      pillow1.style.border = `solid 3px ${colorOptionsMain[RandomNumber1].minor}`
      pillow1.style.background = colorOptionsMain[RandomNumber1].main
    } else if (colorOptionsMain[RandomNumber1].type == 'bicolour') {
      pillow1.style.border = 'unset'
      pillow1.style.background = `url('${colorOptionsMain[RandomNumber1].svg}')`
    } else {
      pillow1.style.border = 'unset'
      pillow1.style.background = colorOptionsMain[RandomNumber1].main
    }    

    updateSelector('pillow-1', RandomNumber1)
    getProduct('pillow-1', RandomNumber1)

    pillow2.setAttribute('data-index', RandomNumber1)
    updateSelector('pillow-2', RandomNumber1)

    if (colorOptionsMain[RandomNumber1].type == 'contrast') {
      pillow2.style.background = colorOptionsMain[RandomNumber1].main
      pillow2.style.border = `solid 3px ${colorOptionsMain[RandomNumber1].minor}`
      if (window.innerWidth < 990) {
        pillow2.style.borderLeft = `solid 0px ${colorOptionsMain[RandomNumber1].minor}`
      } else {
        pillow2.style.borderTop = `solid 0px ${colorOptionsMain[RandomNumber1].minor}`
      }
    } else if (colorOptionsMain[RandomNumber1].type == 'bicolour') {
      pillow2.style.border = 'unset'
      pillow2.style.background = `url('${colorOptionsMain[RandomNumber1].svg}')`
    } else {
      pillow2.style.background = colorOptionsMain[RandomNumber1].main
      pillow2.style.border = 'unset'
    }

    pillow3.setAttribute('data-index', RandomNumber2)
    updateSelector('pillow-3', RandomNumber2)
    getProduct('pillow-2', RandomNumber2)

    if (colorOptionsMain[RandomNumber2].type == 'contrast') {
      pillow3.style.border = `solid 3px ${colorOptionsMain[RandomNumber2].minor}`
      pillow3.style.background = colorOptionsMain[RandomNumber2].main
    } else if (colorOptionsMain[RandomNumber2].type == 'bicolour') {
      pillow3.style.border = 'unset'
      pillow3.style.background = `url('${colorOptionsMain[RandomNumber2].svg}')`
    } else {
      pillow3.style.border = 'unset'
      pillow3.style.background = colorOptionsMain[RandomNumber2].main
    }

    pillow4.setAttribute('data-index', RandomNumber2)
    updateSelector('pillow-4', RandomNumber2)
    if (colorOptionsMain[RandomNumber2].type == 'contrast') {
      pillow4.style.border = `solid 3px ${colorOptionsMain[RandomNumber2].minor}`
      if (window.innerWidth < 990) {
        pillow4.style.borderLeft = `solid 0px ${colorOptionsMain[RandomNumber2].minor}`
      } else {
        pillow4.style.borderTop = `solid 0px ${colorOptionsMain[RandomNumber2].minor}`
      }
      pillow4.style.background = colorOptionsMain[RandomNumber2].main
    } else if (colorOptionsMain[RandomNumber2].type == 'bicolour') {
      pillow4.style.border = 'unset'
      pillow4.style.background = `url('${colorOptionsMain[RandomNumber2].svg}')`
    } else {
      pillow4.style.border = 'unset'
      pillow4.style.background = colorOptionsMain[RandomNumber2].main
    }


    flatSheet.setAttribute('data-index', RandomNumber3)
    flatSheet.style.background = colorOptionsSecondary[RandomNumber3].main
    updateSelector('flat-sheet', RandomNumber3)
    getProduct('flat-sheet', RandomNumber3)
    flatSheet.style.border = 'unset'

    fittedSheet.setAttribute('data-index', RandomNumber4)
    fittedSheet.style.background = colorOptionsSecondary[RandomNumber4].main
    updateSelector('fitted-sheet', RandomNumber4)
    getProduct('fitted-sheet', RandomNumber4)
    fittedSheet.style.border = 'unset'

    duvetCover.setAttribute('data-index', RandomNumber5)
    updateSelector('duvet-cover', RandomNumber5)
    getProduct('duvet-cover', RandomNumber5)

    if (colorOptionsMain[RandomNumber5].type == 'contrast') {
      duvetCover.style.border = `solid 3px ${colorOptionsMain[RandomNumber5].minor}`
      duvetCover.style.background = colorOptionsMain[RandomNumber5].main
    } else if (colorOptionsMain[RandomNumber5].type == 'bicolour') {
      duvetCover.style.border = 'unset'
      duvetCover.style.background = `url('${colorOptionsMain[RandomNumber5].svg}')`
    } else {
      duvetCover.style.border = 'unset'
      duvetCover.style.background = colorOptionsMain[RandomNumber5].main
    }

  }

// CHOOSE FRAME
function chooseFrame(e, number) {
  document.querySelector('.position-1-product').classList.remove('euro-selected')
  document.querySelector('.position-2-product').classList.remove('euro-selected')
    var frameButtons = document.querySelectorAll(".frame-button")
    for (let i = 0; i < frameButtons.length; i++) {
      const element = frameButtons[i];
      if (element == e) {
        element.classList.add('active')
      } else {
        element.classList.remove('active')
      }
    }

    var pillow1Index = document.querySelector('[data-name="pillow-1"]').getAttribute('data-index')
    var pillow3Index = document.querySelector('[data-name="pillow-3"]').getAttribute('data-index')
    var flatSheetIndex = document.querySelector('[data-name="flat-sheet"]').getAttribute('data-index')
    var fittedSheetIndex = document.querySelector('[data-name="fitted-sheet"]').getAttribute('data-index')
    var duvetCoverIndex = document.querySelector('[data-name="duvet-cover"]').getAttribute('data-index')
    document.querySelector('.bys-container').setAttribute('data-pieces', number)
    document.querySelector('.bottom-bar').setAttribute('data-pieces', number)

    if (number == 4) {
      document.querySelector('[data-name="flat-sheet"]').setAttribute('data-disabled', "true")
      document.querySelector('[data-name="pillow-3"]').setAttribute('data-disabled', "true")
      document.querySelector('[data-name="pillow-4"]').setAttribute('data-disabled', "true")

    
      getProduct('pillow-1', pillow1Index)
      getProduct('fitted-sheet', fittedSheetIndex)
      getProduct('duvet-cover', duvetCoverIndex)

    } else if (number == 5) {
      document.querySelector('[data-name="pillow-3"]').setAttribute('data-disabled', "true")
      document.querySelector('[data-name="pillow-4"]').setAttribute('data-disabled', "true")
      getProduct('pillow-1', pillow1Index)
      getProduct('flat-sheet', flatSheetIndex)
      getProduct('fitted-sheet', fittedSheetIndex)
      getProduct('duvet-cover', duvetCoverIndex)
    } else if (number == 6) {
      document.querySelector('[data-name="flat-sheet"]').setAttribute('data-disabled', "true")
      document.querySelector('[data-name="pillow-3"]').setAttribute('data-disabled', "false")
      document.querySelector('[data-name="pillow-4"]').setAttribute('data-disabled', "false")
      getProduct('pillow-1', pillow1Index)
      getProduct('pillow-2', pillow3Index)
      getProduct('fitted-sheet', fittedSheetIndex)
      getProduct('duvet-cover', duvetCoverIndex)
    } else if (number == 7) {
      document.querySelector('[data-name="flat-sheet"]').setAttribute('data-disabled', "false")
      document.querySelector('[data-name="pillow-3"]').setAttribute('data-disabled', "false")
      document.querySelector('[data-name="pillow-4"]').setAttribute('data-disabled', "false")
      getProduct('pillow-1', pillow1Index)
      getProduct('pillow-2', pillow3Index)
      getProduct('flat-sheet', flatSheetIndex)
      getProduct('fitted-sheet', fittedSheetIndex)
      getProduct('duvet-cover', duvetCoverIndex)
    }

    document.querySelector('.bys-container').classList.add('load')

    setTimeout(() => {document.querySelector('.bys-container').classList.remove('load')}, 2000)
  
    updateSelectionFrame() 
  }

// BOTTOM BAR 

function updateSelector(block, index) {
  var bottomBar = document.querySelector('.bottom-bar')
  var pieces = bottomBar.getAttribute('data-pieces')
  console.log(`📊 UPDATESELECTOR: Updating ${block} with index ${index} for ${pieces} pieces`);

  if (pieces == 4) {
    if (block == 'pillow-1' || block == 'pillow-2') {
      document.querySelector('.selection-one [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'fitted-sheet') {
      document.querySelector('.selection-two [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'duvet-cover') {
      document.querySelector('.selection-three [data-color]').innerHTML = colorOptionsMain[index].color_name
    }
  } else  if (pieces == 5) {
    if (block == 'pillow-1' || block == 'pillow-2') {
      document.querySelector('.selection-one [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'fitted-sheet') {
      document.querySelector('.selection-two [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'flat-sheet') {
      document.querySelector('.selection-three [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'duvet-cover') {
      document.querySelector('.selection-four [data-color]').innerHTML = colorOptionsMain[index].color_name
    }
  } else  if (pieces == 6) {
    if (block == 'pillow-1' || block == 'pillow-2') {
      document.querySelector('.selection-one [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'pillow-3' || block == 'pillow-4') {
      document.querySelector('.selection-two [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'fitted-sheet') {
      document.querySelector('.selection-three [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'duvet-cover') {
      document.querySelector('.selection-four [data-color]').innerHTML = colorOptionsMain[index].color_name
    }
  } else  if (pieces == 7) {
    if (block == 'pillow-1' || block == 'pillow-2') {
      document.querySelector('.selection-one [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'pillow-3' || block == 'pillow-4') {
      document.querySelector('.selection-two [data-color]').innerHTML = colorOptionsMain[index].color_name
    } else if (block == 'fitted-sheet') {
      document.querySelector('.selection-three [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'flat-sheet') {
      document.querySelector('.selection-four [data-color]').innerHTML = colorOptionsSecondary[index].color_name
    } else if (block == 'duvet-cover') {
      document.querySelector('.selection-five [data-color]').innerHTML = colorOptionsMain[index].color_name
    }
  }
}

// CHANGE COLOR 

function changeColor(e) {
  document.querySelector('.position-1-product').classList.remove('euro-selected')
  document.querySelector('.position-2-product').classList.remove('euro-selected')
  var dataName = e.getAttribute('data-name')
  var matchingPillow =  null 
  var currentIndex = e.getAttribute('data-index')
 
  if (dataName == 'pillow-1') {
    if (currentIndex == colorOptionsMain.length - 1) {
      var nextIndex = 0
    } else {
      var nextIndex = Number(currentIndex) + 1 
    }
    e.setAttribute('data-index', nextIndex)

    var matchingPillow = document.querySelector('[data-name="pillow-2"]')
    var nextColor = colorOptionsMain[nextIndex].main
    var minorColor = colorOptionsMain[nextIndex].minor
    var svgImage = colorOptionsMain[nextIndex].svg
    var type = colorOptionsMain[nextIndex].type

    getProduct('pillow-1', nextIndex)
  } else if (dataName == 'pillow-2') {
    if (currentIndex == colorOptionsMain.length - 1) {
      var nextIndex = 0
    } else {
      var nextIndex = Number(currentIndex) + 1 
    }
    e.setAttribute('data-index', nextIndex)

    var matchingPillow = document.querySelector('[data-name="pillow-1"]')
    var nextColor = colorOptionsMain[nextIndex].main
    var minorColor = colorOptionsMain[nextIndex].minor
    var svgImage = colorOptionsMain[nextIndex].svg
    var type = colorOptionsMain[nextIndex].type

    getProduct('pillow-1', nextIndex)
  } else if (dataName == 'pillow-3') {
    if (currentIndex == colorOptionsMain.length - 1) {
      var nextIndex = 0
    } else {
      var nextIndex = Number(currentIndex) + 1 
    }
    e.setAttribute('data-index', nextIndex)

    var matchingPillow = document.querySelector('[data-name="pillow-4"]')
    var nextColor = colorOptionsMain[nextIndex].main
    var minorColor = colorOptionsMain[nextIndex].minor
    var svgImage = colorOptionsMain[nextIndex].svg
    var type = colorOptionsMain[nextIndex].type

    getProduct('pillow-2', nextIndex)
  } else if (dataName == 'pillow-4') {
    if (currentIndex == colorOptionsMain.length - 1) {
      var nextIndex = 0
    } else {
      var nextIndex = Number(currentIndex) + 1 
    }
    e.setAttribute('data-index', nextIndex)

    var matchingPillow = document.querySelector('[data-name="pillow-3"]')
    var nextColor = colorOptionsMain[nextIndex].main
    var minorColor = colorOptionsMain[nextIndex].minor
    var svgImage = colorOptionsMain[nextIndex].svg
    var type = colorOptionsMain[nextIndex].type

    getProduct('pillow-2', nextIndex)
  } else if (dataName == 'duvet-cover') {
    if (currentIndex == colorOptionsMain.length - 1) {
      var nextIndex = 0
    } else {
      var nextIndex = Number(currentIndex) + 1 
    }
    e.setAttribute('data-index', nextIndex)


    getProduct(dataName, nextIndex)
    var nextColor = colorOptionsMain[nextIndex].main
    var minorColor = colorOptionsMain[nextIndex].minor
    var svgImage = colorOptionsMain[nextIndex].svg
    var type = colorOptionsMain[nextIndex].type

  } else {
    // For sheets, find next color with the required product type
    var startIndex = Number(currentIndex);
    var nextIndex = startIndex;
    var attempts = 0;
    
    do {
      if (nextIndex == colorOptionsSecondary.length - 1) {
        nextIndex = 0;
      } else {
        nextIndex = Number(nextIndex) + 1;
      }
      attempts++;
      
      // Check if this color has the product we need (flat-sheet or fitted-sheet)
      if (colorOptionsSecondary[nextIndex].product[dataName]) {
        break;
      }
    } while (nextIndex !== startIndex && attempts < colorOptionsSecondary.length);
    
    e.setAttribute('data-index', nextIndex)

    getProduct(dataName, nextIndex)
    var nextColor = colorOptionsSecondary[nextIndex].main
    var type = colorOptionsSecondary[nextIndex].type
  }

  
  if (type == 'contrast') {
    e.style.background = nextColor
    e.style.border = `solid 3px ${minorColor}`
    if (dataName == 'pillow-2' || dataName == 'pillow-4'){
      if (window.innerWidth < 990) {
        e.style.borderLeft = `solid 0px ${minorColor}`
      } else {
        e.style.borderTop = `solid 0px ${minorColor}`
      }
    }
  } else if (type == 'bicolour') {
    e.style.background = `url('${svgImage}')`
    e.style.border = `unset`      
  } else {
    e.style.background = nextColor
    e.style.border = `unset`
  }


  if (matchingPillow != null) {
    matchingPillow.setAttribute('data-index', nextIndex)
    var matchingName = matchingPillow.getAttribute('data-name')
    if (type == 'contrast') {
      matchingPillow.style.background = nextColor
      matchingPillow.style.border = `solid 3px ${minorColor}`
      if (matchingName == 'pillow-2' || matchingName == 'pillow-4') {
        if (window.innerWidth < 990) {
          matchingPillow.style.borderLeft = `solid 0px ${minorColor}`
        } else {
          matchingPillow.style.borderTop = `solid 0px ${minorColor}`
        }
      }
    } else if (type == 'bicolour') {
      matchingPillow.style.background = `url('${svgImage}')`
      matchingPillow.style.border = `unset`      
    } else {
      matchingPillow.style.background = nextColor
      matchingPillow.style.border = `unset`
    }
  
  }
 
  updateSelector(dataName, nextIndex)
}